import * as React from 'react';
import ThemeControls from "../AllThemesControl";
import Button           from '../../FormsControls/Button';
import Element          from '../../FormsControls/Element';
import { FormContext }  from '../Forms/FormContext';
import CloseIcon from '@mui/icons-material/Close';
import {IoWarningOutline } from 'react-icons/io5';
import elementValidation from '../validation.js';
// import delJSON from './DeleteJson.json';
import Loading from '../../images/Table/Loading.gif';
import {APIGET, APIDEL, APIPOST} from '../../services/APIServices';
import SuccessPage      from '../SuccessPage.js';

export default function Delete(props){ 
  const {useStyles} = ThemeControls;
  const delJSON = props.json;
    const [delResponse,setDelResponse] = React.useState();
    const [data,setData] = React.useState();
    const [elements,setElements] = React.useState(null);
    // const apiPath = props.apiContext.toString();
    const deleteType = props.deleteType
    const apiContextObj = props.apiContextObj
    const formFieldsJson = props.formFieldsJson
    const selectedBulk = props.selectedBulk

    const classes = useStyles();
    const {index,dataArr,contextJson} = props;
    const [successRender, setSuccessRender] = React.useState(undefined);
    const [successPageData, setSuccessPageData] = React.useState(undefined);

    function renderSuccessPage(props){
      setSuccessPageData(props)
      setSuccessRender(1);
    }

    React.useEffect(()=>{
        setElements(delJSON.fields)
        
        delJSON.fields.map((field,i)=>{
          (field.field_value = "")
        })
    },[])
console.log(dataArr)
    const {fields} = elements ?? {}
      function setErrorMsg(msg){
        alert(msg)
      }
    //handle change==>
    const handleChange = (id,event,valueStr) => {
        const newElements = { ...elements }
        delJSON.fields.forEach(field => {
          const { field_type, field_id } = field;
          if (id === field_id) {
            switch (field_type) {
              case 'checkbox':
                field['field_value'] = event.target.checked;
                break;

              default:
                field['field_value'] = valueStr;
                break;
            }
          }
          setElements(newElements);
        });
      }
   
      async function deletingData(value) {
        let data = {};
     
        data['active'] = "D";
        data['reasonForDeletion'] = value;
    
        try {
          const response = await APIDEL(apiContextObj.deleteFlow.apiContext + '/' + dataArr[apiContextObj.id], data, formFieldsJson, renderSuccessPage,setErrorMsg);
          if (response) {
            return response;
          }
        } catch (error) {
          console.error(error);
          throw error;
        }
      }
      async function deletingDataFilter(value, path) {
        let data = {};
     
        data['active'] = "D";
        data['reasonForDeletion'] = value;
    
        try {
          const response = await APIDEL(path, data, formFieldsJson, renderSuccessPage,setErrorMsg);
          if (response) {
            return response;
          }
        } catch (error) {
          console.error(error);
          throw error;
        }
      }

      async function bulkDelete(data) {
      
        try {
          const response = await APIPOST(apiContextObj.deleteFlow.apiContext, data, formFieldsJson,renderSuccessPage, setErrorMsg);
          if (response) {
            return response.data
          }
        } catch (error) {
          console.error(error);
          throw error;
        }
      }
   console.log(selectedBulk) 
    
    //Handle Deletion ===>
    const handleDeletion =()=>{
      let validData = true;

      delJSON.fields.map((field,index)=>{
        if(!elementValidation(field)){
          validData = false;
        }
      });
      if((delJSON.fields[1].field_value==="Delete"||delJSON.fields[1].field_value==="delete")&&validData){
        if(deleteType==='bulk'){
          const data={}
          const result = selectedBulk.join();
          data['ids'] = result;
          data['invoiceType'] = "c";
          bulkDelete(data)
        } else if(deleteType==='custom'){
          const customerRateDetail = selectedBulk
          const searchData = {customerRateDetail};
          searchData[delJSON?.fields[0]?.field_id]=delJSON.fields[0].field_value
          Object.keys(contextJson).forEach((key, index) => {
            if (key !== "xioFEConfig") {
              contextJson[key].fields.forEach((field) => {
                if(field.field_temp_id){
                  searchData[field.field_temp_id] = field.field_value;
                }
              });
            }
          });
          bulkDelete(searchData)
        } else if(deleteType==='custom_single'){
          if (Array.isArray(apiContextObj?.deleteFlow?.id) && apiContextObj?.deleteFlow?.id) {
            let formattedString = "";
            apiContextObj?.deleteFlow?.id.forEach((key) => {
              const value = dataArr[key];
              if (value !== undefined) {
                formattedString += `/${value}`;
              }
            });
            // Remove the last '&' character
            formattedString = formattedString.slice(0, -1);
            const url = `${apiContextObj?.deleteFlow?.apiContext}${formattedString}`;
            deletingDataFilter(delJSON.fields[0].field_value,url)
          }
        }else{
    
          if (Array.isArray(apiContextObj?.deleteFlow?.id) && apiContextObj?.deleteFlow?.id) {
            let formattedString = "";
            apiContextObj?.deleteFlow?.id.forEach((key) => {
              const value = dataArr[key];
              if (value !== undefined) {
                formattedString += `${key}=${value}&`;
              }
            });
            // Remove the last '&' character
            formattedString = formattedString.slice(0, -1);
            const url = `${apiContextObj?.deleteFlow?.apiContext}${formattedString}`;
            deletingDataFilter(delJSON.fields[0].field_value,url)
          } else {
            deletingData(delJSON.fields[0].field_value);
          }
          
        }
        }
      else{
        delJSON.fields[1].field_helperText = "You have enter 'Delete'";
          setDelResponse(delJSON.fields);
      }
      }
    const handleCancel=()=>{
      delJSON.fields.map((field,index)=>{
      delJSON.fields[index].field_helperText=undefined;
      delJSON.fields[index].field_value=undefined;});

      props.close();
    }

    if(!data){
      return(
        <>
        <div className={classes.closeup}>
           <CloseIcon onClick={()=>(handleCancel())}/>
           <div className={classes.bdr}>
                  <h4>{deleteType==='bulk' || deleteType === 'custom'?'Permanently Delete Selected Items':'Permanently Delete'}</h4>
                  {/* <h4>Permanently Delete : {data[`${props.policyLabelOnDelete}`]}</h4> */}
                  <div></div>
              </div>
            </div>
            {(successRender && successPageData) ?
          <SuccessPage
            flowName={props.contextHeading || apiContextObj.deleteFlow.contextHeading}
            actionName="Deleted"
            // createButtonText={successPageData.createButtonText}
            // viewButtonText={successPageData.viewButtonText}
            // paragraphText={successPageData.paragraphText}
          />
          :
          <div className={classes.preview}>
          <div>
              <p className={classes.warningSvg}><IoWarningOutline />Warning:You cannot undo the action. The following will be delete forever</p>
              <div className={classes.bdr}>
                  <div className={classes.dellabel}>
                      <div className={classes.flx2}>
                         {deleteType==='bulk'?'Selected Items':'Name'} : 
                         <span>
                          <b>
                            {deleteType==='bulk'?selectedBulk.join():deleteType==='custom'?' '+ apiContextObj?.deleteFlow?.contextHeading: dataArr?.[apiContextObj?.deleteFlow?.deleteLabelId]!==undefined? ' '+ dataArr?.[apiContextObj?.deleteFlow?.deleteLabelId]:' '+ apiContextObj?.deleteFlow?.contextHeading}
                          </b>
                          </span>
                      </div>
                  </div>
              </div>
          
          <FormContext.Provider value={{handleChange}}>
                  <div className={classes.delCotnr}>
                      {delJSON.fields?delJSON.fields.map((field,i)=><Element key={i} field={field}/>):null}   
              </div>
          </FormContext.Provider>
          </div>
          <div className={classes.deleteBtn}> 
            <Button ButtonName="Cancel" onClick={()=>(handleCancel())}/>
            <Button ButtonName="Delete" onClick={()=>(handleDeletion())} />
          </div>
      </div>
      }
        </>    
      )
    }else{
      return <div className={classes.loading}><img src={Loading} alt="Loading..." /><CloseIcon onClick={()=>(handleCancel())}/></div>
    }
}

